module.exports = __webpack_public_path__ + "static/media/DiskScheduling.b2580296.webp";